export default {
    apiKey: "AIzaSyAoeOCIge46KJZQtpueoOtmA3SY4cb6T2k",
    authDomain: "whatsappclone-78df4.firebaseapp.com",
    projectId: "whatsappclone-78df4",
    storageBucket: "whatsappclone-78df4.appspot.com",
    messagingSenderId: "355663109584",
    appId: "1:355663109584:web:0b272fabbc8caddc43edd5",
    measurementId: "G-NH8PPMKYEY"
  };